<template>
    <div id="appdownload">
        <img src="https://dponlinedownload.parrowtech.com/mn_logo.png" height="57" width="57" />
        <div>新恒瑞医药</div>
        <div>点击下载</div>
        <section v-if="!isWeixinOpen">
            <button @click="openAndroid()">安卓下载</button>
        </section>
        <section v-if="!isWeixinOpen">
            <button @click="openIos()">苹果下载</button>
        </section>
        <article v-if="isWeixinOpen">
            微信浏览器不支持本APP下载，请点击右上角使用系统浏览器打开页面进行下载
        </article>
    </div>
</template>

<script>
    import { GetAppVersion } from "../../api/api";

    export default {
        name: "Login",
        data() {
            return {
                android: {
                    AppVersion: '',
                    AppUrl: '',
                    H5Version: '',
                    H5Url: ''
                },
                ios: {
                    AppVersion: '',
                    IPAUrl: '',
                    AppUrl: '',
                    H5Version: '',
                    H5Url: ''
                },
                isWeixinOpen:true,
                isIosOpen:false,
            }
        },
        mounted() {
            this.getAppVersion();
            this.isWeixinOpen = this.isWeixin();
            this.isIosOpen = this.isIos();
        },
        methods: {
            getAppVersion() {
                this.loading = true;

                GetAppVersion().then(res => {
                    this.loading = false;
                    if (res.data.Code != 1) return;
                    this.android.AppVersion = res.data.Data.AdAppVersion;
                    this.android.AppUrl = res.data.Data.AdAppUrl;
                    this.android.H5Version = res.data.Data.AdH5Version;
                    this.android.H5Url = res.data.Data.AdH5Url;

                    this.ios.AppVersion = res.data.Data.IosAppVersion;
                    this.ios.AppUrl = res.data.Data.IosAppUrl;
                    this.ios.IPAUrl = res.data.Data.IosIpaUrl;
                    this.ios.H5Version = res.data.Data.IosH5Version;
                    this.ios.H5Url = res.data.Data.IosH5Url;
                });
            },
            isWeixin() {
                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    return true;
                } else {
                    return false;
                }
            },
            openIos() {
                window.location.href = this.ios.AppUrl;
            },
            openAndroid() {
                window.location.href = this.android.AppUrl;
            },
            isIos() {
                var ua = navigator.userAgent.toLowerCase();
                if (!/iphone|ipad|ipod/.test(ua))
                    return false;
                return true;
            },
        }
    }
</script>


<style scoped>
    @import "../../assets/css/other/appdownload.css";
</style>


// WEBPACK FOOTER //
// src/components/other/AppDownload.vue